import React from "react";
import { useParams } from "react-router-dom";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import SettingsPageContent from "../../components/Design/Settings/SettingsPageContent";
import { Routing } from "../../data/Constants/Routing";
import { useApiStates } from "../../state/Store";
import ExecutionInfo from "./ExecutionInfo";

interface Params extends Record<string, string | undefined> {
    executionId: string;
}

const EditExecutionScreen: React.FC = () => {
    const params = useParams<Params>();

    const api = useApiStates("executions", "scenarios", "roles", "workers", "executionErrors");
    const execution = api.executions.value?.find(e => e.id === params.executionId);

    return (
        <SettingsPage
            breadcrumbs={[{
                title: "Ausführungen",
                link: Routing.Administration.Execution.Navigate()
            }]}
            title={execution?.name ?? "Ausführung bearbeiten"}>

            <SettingsPageContent
                api={api}
                error={!execution && "Ausführung nicht gefunden!"}>

                <ExecutionInfo
                    execution={execution}
                    executionErrors={api.executionErrors.value ?? []}
                    scenarios={api.scenarios.value ?? []}
                    workers={api.workers.value ?? []}
                    roles={api.roles.value ?? []} />

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default EditExecutionScreen;
